import React from "react"

import { KlaviyoEmbedInterface } from "./KlaviyoEmbed.interface"
import * as s from "./KlaviyoEmbed.module.scss"

export const KlaviyoEmbed = ({ data }: KlaviyoEmbedInterface) => {
  const { klaviyoId, color } = data

  const colorClass = (bgColor) => {
    switch (bgColor) {
      case "black":
        return s.klaviyoEmbed__black
      case "red":
        return s.klaviyoEmbed__red
      case "yellow":
        return s.klaviyoEmbed__yellow
      default:
        return "" // Return an empty string or a default class if no color matches
    }
  }

  return (
    <div className={`${s.klaviyoEmbed} ${colorClass(color)}`} id="klaviyoForm">
      <div className={`klaviyo-form-${klaviyoId}`}></div>
    </div>
  )
}
